import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

// Four files each carried their own `t` wrapper around the same namespace-prefixing line.
// Called with no prefix it is a plain translate, which is what `resolveC2cErrorMessage`
// needs (its keys are absolute).
export const useNamespacedT = (prefix = '') => {
  const { i18n } = useTranslation()
  return useCallback((key, opts) => i18n.t(prefix ? `${prefix}.${key}` : key, opts), [i18n, prefix])
}
